import { render } from "./SimpleSection.vue?vue&type=template&id=191bf644"
import script from "./SimpleSection.vue?vue&type=script&lang=js"
export * from "./SimpleSection.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__